import { render } from "./SuperPacmanInstallmentsView.vue?vue&type=template&id=70b7e388&scoped=true&ts=true"
import script from "./SuperPacmanInstallmentsView.vue?vue&type=script&lang=ts"
export * from "./SuperPacmanInstallmentsView.vue?vue&type=script&lang=ts"

import "./SuperPacmanInstallmentsView.vue?vue&type=style&index=0&id=70b7e388&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b7e388"]])

export default __exports__